import Hero from '../../components/sections/Hero';
import About from '../../components/sections/About';
import WhoShouldApply from '../../components/sections/WhoShouldApply';
import PitchExpectations from '../../components/sections/PitchExpectations';
import Benefits from '../../components/sections/Benefits';
import HowItWorks from '../../components/sections/HowItWorks';
import Investors from '../../components/sections/Investors';
import FAQs from '../../components/sections/FAQs';
import Partners from '../../components/sections/Partners';
import ContactUs from '../../components/sections/ContactUs';
import Navbar from "../../components/navbar/index.jsx";
import Footer from "../../components/Footer/Footer";

function PitchBusiness() {
  return (
    <div className="bg-slate-800">
      <Navbar />
      <Hero />
      <About />
      <WhoShouldApply />
      <PitchExpectations />
      <Benefits />
      <HowItWorks />
      <Investors />
      <FAQs />
      <Partners />
      <ContactUs />
      <Footer />
    </div>
  );
}

export default PitchBusiness;